
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  id: '548a2c6268',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page appointment-details-page" data-name="appointment-details">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Appointment Details</div>\n            </div>\n        </div>\n        <div class="page-content">\n\n            <!-- Hero: doctor + status -->\n            <div class="apd-hero">\n                <div class="apd-hero-top">\n                    <div class="apd-hero-photo">\n                        <img src="';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.doctorPhoto, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.data.doctorPhoto, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'static/img/default_doctor.svg';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\n                    </div>\n                    <div class="apd-hero-info">\n                        <div class="apd-hero-doctor">Dr. ';
      r += c(ctx_1.data.doctorName, ctx_1);
      r += '</div>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.doctorDegree, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="apd-hero-degree">';
          r += c(ctx_2.data.doctorDegree, ctx_2);
          r += '</div>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.depName, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="apd-hero-dept">';
          r += c(ctx_2.data.depName, ctx_2);
          r += '</div>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </div>\n                <div class="apd-hero-foot">\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.is_bookConfirmed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <span class="appt-status appt-status-confirmed">\n                        <i class="icon f7-icons if-not-md">checkmark_seal_fill</i>\n                        <i class="icon material-icons md-only">verified</i>\n                        Confirmed\n                    </span>\n                    ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <span class="appt-status appt-status-pending">\n                        <i class="icon f7-icons if-not-md">clock</i>\n                        <i class="icon material-icons md-only">schedule</i>\n                        Pending\n                    </span>\n                    ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    <span class="apd-hero-id">ID #';
      r += c(ctx_1.data.pre, ctx_1);
      r += c(ctx_1.data.id, ctx_1);
      r += '</span>\n                </div>\n            </div>\n\n            <!-- Date & time block -->\n            <section class="apd-section">\n                <div class="apd-section-title">Date &amp; Time</div>\n                <div class="apd-datetime-card">\n                    <div class="apd-datepad">\n                        <div class="apd-datepad-day">';
      r += c(ctx_1.data.day, ctx_1);
      r += '</div>\n                        <div class="apd-datepad-date">';
      r += c(ctx_1.data.date, ctx_1);
      r += '</div>\n                        <div class="apd-datepad-month">';
      r += c(ctx_1.data.month, ctx_1);
      r += '</div>\n                    </div>\n                    <div class="apd-datetime-info">\n                        <div class="apd-datetime-time">\n                            <i class="icon f7-icons if-not-md">clock_fill</i>\n                            <i class="icon material-icons md-only">schedule</i>\n                            <span>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.is_dateConfirmed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.data.confirmTime, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.data.time, ctx_2);
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span>\n                        </div>\n                        <div class="apd-datetime-status">\n                            <span class="apd-datetime-label">Time slot</span>\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.is_dateConfirmed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <span class="apd-dot apd-dot-confirm"></span>\n                            <span class="apd-datetime-value apd-datetime-value-confirm">Confirmed</span>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <span class="apd-dot apd-dot-pending"></span>\n                            <span class="apd-datetime-value apd-datetime-value-pending">Pending</span>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- Payment block -->\n            <section class="apd-section">\n                <div class="apd-section-title">Payment</div>\n                <div class="apd-payment-card">\n                    <div class="apd-payment-row">\n                        <span>Amount</span>\n                        <strong>\u20B9 ';
      r += c(ctx_1.data.payableAmount, ctx_1);
      r += '</strong>\n                    </div>\n                    <div class="apd-payment-row">\n                        <span>Booking ID</span>\n                        <span class="apd-payment-id">';
      r += c(ctx_1.data.pre, ctx_1);
      r += c(ctx_1.data.id, ctx_1);
      r += '</span>\n                    </div>\n                    <div class="apd-payment-row apd-payment-row-status">\n                        <span>Status</span>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.is_bookConfirmed, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <span class="apd-chip apd-chip-confirm">Paid</span>\n                        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <span class="apd-chip apd-chip-pending">Pending</span>\n                        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </div>\n            </section>\n\n            <!-- Patient block -->\n            <section class="apd-section">\n                <div class="apd-section-title">Patient</div>\n                <div class="apd-info-card">\n                    <div class="apd-info-row">\n                        <div class="apd-info-icon apd-info-icon-green">\n                            <i class="icon f7-icons if-not-md">person_fill</i>\n                            <i class="icon material-icons md-only">person</i>\n                        </div>\n                        <div class="apd-info-body">\n                            <div class="apd-info-title">';
      r += c(ctx_1.data.name, ctx_1);
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.gender, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <span class="apd-info-sub">(';
          r += c(ctx_2.data.gender, ctx_2);
          r += Template7Helpers.if.call(ctx_2, ctx_2.data.age, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' \xB7 ';
              r += c(ctx_3.data.age, ctx_3);
              r += ' yrs';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ')</span>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n                        </div>\n                    </div>\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.mobile, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <a href="tel:';
          r += c(ctx_2.data.mobile, ctx_2);
          r += '" class="apd-info-row apd-info-row-link external">\n                        <div class="apd-info-icon apd-info-icon-blue">\n                            <i class="icon f7-icons if-not-md">phone_fill</i>\n                            <i class="icon material-icons md-only">call</i>\n                        </div>\n                        <div class="apd-info-body">\n                            <div class="apd-info-title">';
          r += c(ctx_2.data.mobile, ctx_2);
          r += '</div>\n                            <div class="apd-info-meta">Tap to call</div>\n                        </div>\n                    </a>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.address, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <div class="apd-info-row">\n                        <div class="apd-info-icon apd-info-icon-blue">\n                            <i class="icon f7-icons if-not-md">placemark_fill</i>\n                            <i class="icon material-icons md-only">place</i>\n                        </div>\n                        <div class="apd-info-body">\n                            <div class="apd-info-title">';
          r += c(ctx_2.data.address, ctx_2);
          r += '</div>\n                        </div>\n                    </div>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n            </section>\n\n            <!-- Hospital block -->\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.hospital_name, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <section class="apd-section">\n                <div class="apd-section-title">Hospital</div>\n                <div class="apd-hospital-card">\n                    <div class="apd-hospital-info">\n                        <div class="apd-info-icon apd-info-icon-green">\n                            <i class="icon f7-icons if-not-md">house_fill</i>\n                            <i class="icon material-icons md-only">local_hospital</i>\n                        </div>\n                        <div class="apd-hospital-body">\n                            <div class="apd-hospital-name">';
          r += c(ctx_2.data.hospital_name, ctx_2);
          r += '</div>\n                            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.data.doctorAddress, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="apd-hospital-address">';
              r += c(ctx_3.data.doctorAddress, ctx_3);
              r += '</div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        </div>\n                    </div>\n                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.data.lat, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <a class="apd-hospital-direction link external" href="https://www.google.com/maps/place/';
              r += c(ctx_3.data.lat, ctx_3);
              r += '+';
              r += c(ctx_3.data.log, ctx_3);
              r += '" target="_system" aria-label="Get directions">\n                        <i class="icon material-icons">directions</i>\n                    </a>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </div>\n            </section>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <!-- Invoice actions -->\n            <div class="apd-actions">\n                <a class="apd-action-btn link external" href="';
      r += c(ctx_1.$root.remoteUrl, ctx_1);
      r += 'printBill/';
      r += c(ctx_1.data.printID, ctx_1);
      r += '/" target="_system">\n                    <i class="icon f7-icons if-not-md">doc_text_fill</i>\n                    <i class="icon material-icons md-only">picture_as_pdf</i>\n                    <span>Preview Invoice</span>\n                </a>\n                <a href="#" class="apd-action-btn apd-action-btn-secondary" id="invoiceShareButton" data-url="';
      r += c(ctx_1.$root.remoteUrl, ctx_1);
      r += 'printBill/';
      r += c(ctx_1.data.printID, ctx_1);
      r += '/">\n                    <i class="icon f7-icons if-not-md">square_arrow_up</i>\n                    <i class="icon material-icons md-only">share</i>\n                    <span>Share Invoice</span>\n                </a>\n            </div>\n\n            <div class="apd-bottom-spacer"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    